export function getScrollParent(node: Element | null): Element | null {
    if (!node) {
        return null
    }

    const parent = node.parentElement
    if (!parent) {
        return null
    }

    const style = getComputedStyle(parent)
    const overflow = style.overflow + style.overflowY + style.overflowX
    const overflowRegex = /(auto|scroll|overlay)/

    if (overflowRegex.test(overflow)) {
        return parent
    }

    return getScrollParent(parent)
}
